import { atom } from "recoil";
import { AuthStorageService } from "../services/AuthStorageService";

const AuthState = atom({
    key: 'AuthState',
    default: AuthStorageService.getDefaultModel()
});

export default AuthState;